import { makeAutoObservable, runInAction } from "mobx";
import logAPIHandler from "../handlers/LogAPIHandler";
import webSocketHandler from "../handlers/WebsocketHandler";
import { convertToLocalTime } from "../utils/logDataFilter&Cleaner";
// import {
//   addDeviceToQueue,
//   getFrequentlyViewedDevices,
// } from "../utils/frequentlyViewedDevices";
import {
  normalizeWebSocketLogs,
  normalizeApiLogs,
} from "../utils/newLogDataFilter";

// const MAX_TOTAL_LOGS = 2000;
// const MAX_LOGS_PER_DEVICE = 400;

async function waitForSocketConnection() {
  while (!webSocketHandler.isConnected) {
    await new Promise((res) => setTimeout(res, 100));
  }
}

class LogStore {
  logsMap = new Map(); // log_id => log
  deviceLogIds = new Map(); // device_id => Set<log_id>
  globalLogIds = new Set();
  connectedDeviceIds = new Set();

  frequentlyViewedDevices = []; // up to 5
  currentDeviceId = null;

  connectionStatus = "Disconnected";
  isConnected = false;
  failedConnection = false;
  loading = false;

  MAX_GLOBAL = 2000;
  MAX_PER_DEVICE = 400;

  constructor() {
    makeAutoObservable(this);
    // this.processIncomingLogs = this.processIncomingLogs.bind(this);
    webSocketHandler.subscribe(this.handleWebSocketMessage.bind(this));
  }

  // get currentLogs() {
  //   if (this.currentDeviceId) {
  //     return this.deviceLogsCache.get(this.currentDeviceId) || [];
  //   }
  //   return this.logs;
  // }
  get currentLogs() {
    const ids = this.currentDeviceId
      ? this.deviceLogIds.get(this.currentDeviceId) || new Set()
      : this.globalLogIds;

    return Array.from(ids)
      .map((id) => this.logsMap.get(id))
      .filter(Boolean)
      .sort((a, b) => new Date(b.user_local_t) - new Date(a.user_local_t));
  }

  addToFrequentlyViewed(deviceId) {
    const index = this.frequentlyViewedDevices.indexOf(deviceId);
    if (index !== -1) this.frequentlyViewedDevices.splice(index, 1);
    this.frequentlyViewedDevices.unshift(deviceId);
    if (this.frequentlyViewedDevices.length > 5) {
      this.frequentlyViewedDevices.pop();
    }
  }

  // setDevice(deviceId) {
  //   this.currentDeviceId = deviceId;
  //   addDeviceToQueue(deviceId);
  //   this.ensureDeviceLogs(deviceId);
  //   this.sendSubscription();
  // }
  async setDevice(deviceId) {
    this.currentDeviceId = deviceId;
    this.addToFrequentlyViewed(deviceId);
    await this.loadInitialLogs();
    this.sendSubscription();
  }

  clearDevice() {
    this.currentDeviceId = null;
    this.sendSubscription();
  }

  sendSubscription() {
    const payload = this.currentDeviceId
      ? [this.currentDeviceId]
      : this.frequentlyViewedDevices.slice(0, 5);
    webSocketHandler.send({
      action: "subscribe",
      devices: payload.length ? payload : "*",
    });
  }

  // async ensureDeviceLogs(deviceId) {
  //   if (!this.deviceLogsCache.has(deviceId)) {
  //     this.loading = true;
  //     try {
  //       const res = await logAPIHandler.fetchLatestLogs({
  //         deviceId,
  //         limit: 100,
  //       });
  //       const logs = normalizeApiLogs(res);
  //       runInAction(() => {
  //         const enriched = logs.map((log) => ({
  //           ...log,
  //           user_local_t: convertToLocalTime(log.gw_time_parsed),
  //         }));
  //         const sorted = this.sortByLocalTimeDescending(enriched);
  //         this.deviceLogsCache.set(
  //           deviceId,
  //           this.trim(sorted, MAX_LOGS_PER_DEVICE)
  //         );
  //       });
  //     } catch (e) {
  //       console.error("❌ Failed to load logs for device:", deviceId, e);
  //     } finally {
  //       runInAction(() => {
  //         this.loading = false;
  //       });
  //     }
  //   }
  // }

  // async loadInitialAllLogs() {
  //   this.loading = true;
  //   try {
  //     const res = await logAPIHandler.fetchLatestLogs({ limit: 200 });
  //     console.log("🔍 Raw API Response (count):", res.length);
  //     const logs = normalizeApiLogs(res);

  //     const enriched = logs.map((log) => ({
  //       ...log,
  //       user_local_t: convertToLocalTime(log.gw_time_parsed),
  //     }));
  //     runInAction(() => {
  //       const sorted = this.sortByLocalTimeDescending(enriched);
  //       this.logs = this.trim(sorted, MAX_TOTAL_LOGS);
  //     });
  //   } catch (e) {
  //     console.error("❌ Failed to fetch initial logs:", e);
  //   } finally {
  //     runInAction(() => {
  //       this.loading = false;
  //     });
  //   }
  // }
  async loadInitialLogs() {
    this.loading = true;
    try {
      let res;
      if (this.currentDeviceId) {
        console.log("📡 Fetching logs for device:", this.currentDeviceId);
        res = await logAPIHandler.fetchLatestLogs({
          deviceId: this.currentDeviceId,
          limit: 100,
        });
      } else {
        console.log("📡 Fetching logs for ALL DEVICES");
        res = await logAPIHandler.fetchAllLogs({ limit: 200 });
      }
      console.log("📥 API Response:", res);
      const normalized = normalizeApiLogs(res);
      // this.processIncomingLogs(logs);
      console.log("✅ Normalized Logs from API:", normalized);
      this.storeLogs(normalized, "api");
    } catch (e) {
      console.error("❌ Failed to fetch initial logs:", e);
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  handleWebSocketMessage(data) {
    if (data.type === "log_batch") {
      const logs = normalizeWebSocketLogs(data.logs);
      this.storeLogs(logs, "websocket");
    }
    if (data.type === "device_status") {
      const online = new Set(data.online_devices_id || []);
      this.connectedDeviceIds = online;
      console.log("🟢 Connected devices:", [...online]);

      // Optional: Update per-device map
      // for (const id of this.deviceStatusMap.keys()) {
      //   this.deviceStatusMap.set(id, online.has(id) ? "Connected" : "Not Connected");
      // }
    }
  }

  storeLogs(logs, source = "unknown") {
    if (!Array.isArray(logs)) return;
    console.log(`🧠 Storing logs: ${logs.length} from ${source}`);

    for (const log of logs) {
      const logId = log?.id;
      const devId = log?.device_id;
      if (!logId || !devId || this.logsMap.has(logId)) continue;

      log.user_local_t = convertToLocalTime(log.gw_time_parsed);
      log.source = source;
      this.logsMap.set(logId, log);

      // Always update per-device log map
      if (!this.deviceLogIds.has(devId)) {
        this.deviceLogIds.set(devId, new Set());
      }
      this.deviceLogIds.get(devId).add(logId);
      this.trimDeviceLogs(devId);

      // If in global mode, update global log IDs
      if (!this.currentDeviceId) {
        this.globalLogIds.add(logId);
        this.trimGlobalLogs();
      }
    }

    console.log("📊 logsMap size:", this.logsMap.size);
    console.log(
      "📦 deviceLogIds:",
      Array.from(this.deviceLogIds.entries()).map(([id, set]) => [id, set.size])
    );
    console.log("🌍 globalLogIds:", this.globalLogIds.size);
  }

  trimGlobalLogs() {
    if (this.globalLogIds.size <= this.MAX_GLOBAL) return;
    const sorted = Array.from(this.globalLogIds).sort((aId, bId) => {
      const a = this.logsMap.get(aId);
      const b = this.logsMap.get(bId);
      return new Date(b?.user_local_t) - new Date(a?.user_local_t);
    });

    const excess = sorted.slice(this.MAX_GLOBAL);
    for (const id of excess) {
      this.globalLogIds.delete(id);
      this.deleteIfOrphaned(id);
    }
  }

  trimDeviceLogs(deviceId) {
    const set = this.deviceLogIds.get(deviceId);
    if (!set || set.size <= this.MAX_PER_DEVICE) return;
    const sorted = Array.from(set).sort((aId, bId) => {
      const a = this.logsMap.get(aId);
      const b = this.logsMap.get(bId);
      return new Date(b?.user_local_t) - new Date(a?.user_local_t);
    });

    const excess = sorted.slice(this.MAX_PER_DEVICE);
    for (const id of excess) {
      set.delete(id);
      this.deleteIfOrphaned(id);
    }
  }

  deleteIfOrphaned(logId) {
    const isInGlobal = this.globalLogIds.has(logId);
    const isInAnyDevice = Array.from(this.deviceLogIds.values()).some((set) =>
      set.has(logId)
    );
    if (!isInGlobal && !isInAnyDevice) {
      this.logsMap.delete(logId);
    }
  }

  async connect() {
    if (this.isConnected) return;

    runInAction(() => {
      this.connectionStatus = "Connecting";
      this.isConnected = false;
      this.failedConnection = false;
    });

    webSocketHandler.connect();
    // webSocketHandler.subscribe(this.processIncomingLogs);

    await waitForSocketConnection();

    runInAction(() => {
      this.connectionStatus = "Connected";
      this.isConnected = true;
      this.failedConnection = false;
    });

    this.sendSubscription();
  }

  disconnect() {
    webSocketHandler.disconnect();
    runInAction(() => {
      this.connectionStatus = "Disconnected";
      this.isConnected = false;
    });
  }

  // sendSubscription() {
  //   const devices = this.currentDeviceId
  //     ? [this.currentDeviceId]
  //     : getFrequentlyViewedDevices();

  //   if (!devices.length) {
  //     webSocketHandler.send({ action: "subscribe", devices: "*" });
  //   } else {
  //     webSocketHandler.send({ action: "subscribe", devices });
  //   }
  // }

  // processIncomingLogs(message) {
  //   try {
  //     const logsRaw = Array.isArray(message?.logs)
  //       ? message.logs
  //       : Array.isArray(message)
  //         ? message
  //         : [message];

  //     const activeDevices = new Set();
  //     const normalizedLogs = logsRaw.flatMap((raw) =>
  //       normalizeWebSocketLogs(raw)
  //     );

  //     console.log("🧪 Normalized WebSocket Logs:", normalizedLogs);

  //     for (const log of normalizedLogs) {
  //       if (!log?.id) continue;

  //       const devId = log.device_id;
  //       if (!devId) continue;

  //       log.user_local_t = convertToLocalTime(log.gw_time_parsed);
  //       activeDevices.add(devId);

  //       // 🔁 1. Insert into global log list (if not viewing a device)
  //       if (!this.currentDeviceId && !this.logs.find((l) => l.id === log.id)) {
  //         this.logs.unshift(log);
  //         this.logs = this.trim(this.sortByLocalTimeDescending(this.logs), MAX_TOTAL_LOGS);
  //       }

  //       // 🔁 2. Insert into per-device log cache, always
  //       let deviceLogArr = this.deviceLogsCache.get(devId) || [];

  //       if (!deviceLogArr.find((l) => l.id === log.id)) {
  //         deviceLogArr.unshift(log);
  //         deviceLogArr = this.trim(this.sortByLocalTimeDescending(deviceLogArr), MAX_LOGS_PER_DEVICE);
  //         this.deviceLogsCache.set(devId, deviceLogArr);

  //         // 🧠 Add to device queue — enforces max 5 + evicts if needed
  //         addDeviceToQueue(devId);
  //       }
  //     }

  //     // 🧭 Update status map for devices
  //     runInAction(() => {
  //       activeDevices.forEach((devId) => {
  //         this.deviceStatusMap.set(devId, "Connected");
  //       });
  //       this.deviceStatusMap.forEach((_, devId) => {
  //         if (!activeDevices.has(devId)) {
  //           this.deviceStatusMap.set(devId, "Not Connected");
  //         }
  //       });
  //     });
  //   } catch (err) {
  //     console.error("❌ Failed to process logs:", err);
  //   }
  // }

  // sortByLocalTimeDescending(logs) {
  //   return logs.sort(
  //     (a, b) => new Date(b.user_local_t) - new Date(a.user_local_t)
  //   );
  // }

  // trim(logs, limit) {
  //   return logs.slice(0, limit);
  // }

  // checkForDuplicateLogs() {
  //   console.log("🕵️ Checking for duplicate logs...");

  //   const seen = new Map();
  //   const duplicates = [];

  //   for (const log of this.logs) {
  //     if (!log?.id) continue;

  //     if (!seen.has(log.id)) {
  //       seen.set(log.id, [log]);
  //     } else {
  //       seen.get(log.id).push(log);
  //     }
  //   }

  //   for (const [id, entries] of seen.entries()) {
  //     if (entries.length > 1) {
  //       const sources = entries.map((l) => l.source || "unknown");
  //       duplicates.push({ id, count: entries.length, sources, logs: entries });
  //     }
  //   }

  //   if (duplicates.length > 0) {
  //     console.log("🔍 Duplicate Logs Detected:");
  //     console.table(
  //       duplicates.map((d) => ({
  //         id: d.id,
  //         count: d.count,
  //         sources: d.sources.join(", "),
  //       }))
  //     );
  //   } else {
  //     console.log("No duplication");
  //   }
  // }
}

const logStore = new LogStore();
export default logStore;
